"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import $ from "jquery";
import _ from "underscore";
import {
  toggleAnnotatingStatus,
  adjustTone,
  editTextAnnotationText,
  doneEditingTextAnnotation,
  deleteAnnotation
} from "../redux/actions";
import ApiService from "../../services/api_service";
import Api from "../../api/api";
import Account from "../../api/account";
import DataStoreService from "../data_store_service";
import { connect } from "react-redux";
import { History } from "react-router";
import documentEditor from "../document_editor";
import fetch from "../../util/fetch";
import PageToolbar from "./page_toolbar";
import AnnotateToolbar from "./annotate_toolbar";
import reactUtils from "../../react_utils";
import WaitingSpinner from "../../components/waiting_spinner";
import ZoomableImage from "./zoomable_image";
import Zoomer from "../../helpers/zoomer";
import allowedAsPod from "../../helpers/allowed_as_pod";
import { isOnIndexStep, flowStep } from "../flow_steps";
import allowedAsCarrierDocument from "../../helpers/allowed_as_carrier_document";
import getDocumentAssignmentComponent from "../document_assignment/document_assignment_loader";
import hotkeys from "../../util/hotkeys";
import { assertType } from "../data/types/type_utilities";
import {
  DocumentBatchGroupCreator,
  GroupedDocumentBrowserModel
} from "../grouped_document_browser_model";
import { Flash } from "../../components/flash";
import { readOnly } from "../../helpers/factor_invoice";
import Auth from "../../util/auth";
import { isPodForLoad } from "../helpers/document_load_relationship_helpers";
import { podDispositionLabel } from "./pod_disposition_label";
import {
  shouldShowPodUncheckModal,
  shouldShowPodCheckModal,
  renderPodUncheckReasonModal,
  renderPodCheckReasonModal
} from "../indexer/pod_modal_logic";
import { setPOD } from "../../helpers/documents";
import loadDocumentRelationshipService from "../../services/load_document_relationship_service";
const emptyGroupedDocumentBrowserModel = new GroupedDocumentBrowserModel(
  new DocumentBatchGroupCreator([], () => false)
);
const pageKeyForAttachmentIsProcessingByPage = ({ document_id, number }) => JSON.stringify({ document_id, number });
const bem = reactUtils.makeBem("page-toolbar");
const annotationStampUrl = (model) => model.selectedDocument.annotation_stamp_url;
const carrierDocumentAccount = () => Api.Account.current().settings.carrier_documents_account;
const showDespeckle = () => Api.Account.current().settings.show_despeckle_tone_slider;
const showMarkIllegibleButton = (props) => {
  if (Api.Account.current().factor_account) {
    return !props.currentInvoice || !readOnly(props.currentInvoice);
  } else {
    return !props.isConfirmAndSubmit || props.currentInvoice && !props.currentInvoice.approved_at;
  }
};
const canToggleHidden = (invoice) => {
  return !(invoice == null ? void 0 : invoice.approved_at);
};
const showCarrierDocumentsOption = (document) => carrierDocumentAccount() && allowedAsCarrierDocument(document);
const isGroupedDocumentBrowserModel = (x) => {
  return x != null && typeof x.allDocuments === "function";
};
const viewEmail = (props, history) => {
  return function() {
    const group = props.model.selectedGroup;
    if (!group) {
      return;
    }
    if (group.url && !group.areLoadDocuments) {
      const invoiceId = group.documents[0].carrier_invoice_id || group.documents[0].factor_invoice_id;
      const onDone = props.location.query.onDone || "/dashboard";
      history.pushState(null, group.url, { invoiceId, onDone });
    } else if (group.url && group.areLoadDocuments) {
      const onDone = props.location.query.onDone || "/dashboard";
      history.pushState(null, group.url, { onDone });
    }
  };
};
const documentBrowserSubNav = (props, history) => {
  if (!props.annotating) {
    return /* @__PURE__ */ React.createElement("div", { className: "document-browser__sub-nav" }, /* @__PURE__ */ React.createElement("div", { className: "document-browser__sub-nav_description" }, podStatus(props), clientOrDebtorOnBol(props), carrierDocumentStatus(props)));
  }
};
export const podStatus = (props) => {
  var _a;
  const document = props.model.selectedDocument;
  if (props.allowsEditingPodStatus && !props.annotating && document) {
    if (allowedAsPod(document)) {
      if (isOnIndexStep(props) && props.selectedLoad && props.selectedLoad.requires_auditor_manual_marking_of_POD) {
        return /* @__PURE__ */ React.createElement("div", { className: "document-browser__pod-status" }, /* @__PURE__ */ React.createElement("em", null, "Cannot mark PODs during indexing for this customer"));
      } else if (!isOnIndexStep(props) && Account.podDefinitionModuleEnabled() && !((_a = props.currentInvoice) == null ? void 0 : _a.pod_requirement_skipped)) {
        return /* @__PURE__ */ React.createElement("div", { className: "document-browser__pod-status" }, /* @__PURE__ */ React.createElement("em", null, "Expand POD exception on the left to view and edit POD status."));
      } else {
        const load = props.load || props.selectedLoad;
        const isPod = isPodForLoad(
          document,
          load,
          props.documentLoadRelationships
        );
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "document-browser__pod-status",
            title: "Mark POD - 0 (Numpad) or Alt+D"
          },
          /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "document-browser__pod-status-checkbox",
              checked: isPod,
              onChange: () => props.handlePodToggle ? props.handlePodToggle(document, "includesPOD") : props.toggleDocumentData(document, "includesPOD"),
              type: "checkbox",
              id: "use-as-pod"
            }
          ),
          /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
            "label",
            {
              className: "document-browser__pod-status-label",
              htmlFor: "use-as-pod"
            },
            "Signed: Use as Proof of Delivery"
          ), podDispositionLabel(
            document,
            load,
            props.documentLoadRelationships
          ))
        );
      }
    } else if (!showCarrierDocumentsOption(document)) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-browser__pod-status" }, /* @__PURE__ */ React.createElement("em", null, "This document type may not be used as a proof of delivery."));
    }
  }
};
export const clientOrDebtorOnBol = (props) => {
  const document = props.model.selectedDocument;
  const factorInvoice = props.currentInvoice;
  if (props.allowsEditingPodStatus && !props.annotating && factorInvoice && factorInvoice.show_client_debtor_check && document && document.type == "billOfLading") {
    return /* @__PURE__ */ React.createElement("div", { className: "document-browser__client-or-debtor-status" }, /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "document-browser__pod-status-checkbox",
        onChange: () => props.toggleClientDebtorCheck(factorInvoice),
        type: "checkbox",
        checked: factorInvoice.client_or_debtor_on_bol,
        disabled: props.savingInvoice || readOnly(factorInvoice)
      }
    ), /* @__PURE__ */ React.createElement(
      "label",
      {
        className: "document-browser__pod-status-label",
        htmlFor: "use-as-pod"
      },
      "Client or Debtor on BOL"
    ));
  }
};
export const carrierDocumentStatus = (props) => {
  const document = props.model.selectedDocument;
  if (showCarrierDocumentsOption(document) && props.allowsEditingPodStatus) {
    if (assignedCarrierId(props)) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-browser__pod-status" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "document-browser__pod-status-checkbox",
          checked: !!document.carrier_document_tms_carrier_id,
          onChange: () => {
            props.toggleCarrierDocument(document, assignedCarrierId(props));
          },
          type: "checkbox",
          id: "use-as-carrier_document"
        }
      ), /* @__PURE__ */ React.createElement(
        "label",
        {
          className: "document-browser__pod-status-label",
          htmlFor: "use_as_carrier_document"
        },
        "Save as ",
        Account.carrierTerm(),
        " Document",
        /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "/app/settings/carriers/" + assignedCarrierId(props) + "/documents",
            target: "_blank"
          },
          " ",
          "View current documents for ",
          Account.carrierTermLower(),
          "."
        ))
      ));
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "document-browser__pod-status" }, /* @__PURE__ */ React.createElement("em", null, "You must assign a ", Account.carrierTermLower(), " if you wish to save this as a ", Account.carrierTermLower(), " document."));
    }
  }
};
const assignedCarrierId = (props) => {
  if (props.carrier) {
    return props.carrier.id;
  }
  const batch = props.documentBatch;
  return batch && (batch.carrierId || batch.email_message && batch.email_message.carrier_id);
};
export const DocumentBrowserMainImage = React.createClass(
  assertType({
    mixins: [History],
    // LIFECYCLE
    getInitialState() {
      this.zoomer = new Zoomer();
      const attachmentIsProcessingByPage = (() => {
        return this.allDocumentPages().reduce(
          (attachmentIsProcessingByPage_, page) => {
            const pageKey = pageKeyForAttachmentIsProcessingByPage(page);
            return __spreadProps(__spreadValues({}, attachmentIsProcessingByPage_), {
              [pageKey]: !!page.attachmentIsProcessing
            });
          },
          {}
        );
      })();
      return {
        zoomLevel: this.zoomer.zoomLevel,
        annotating: false,
        justSaved: false,
        showToneSliders: false,
        attachmentIsProcessingByPage,
        // POD reason modal state
        showPodUncheckReasonModal: false,
        podUncheckReasonDocument: null,
        podUncheckReasonLoad: null,
        showPodCheckReasonModal: false,
        podCheckReasonDocument: null,
        podCheckReasonLoad: null
      };
    },
    modelForAnnotations() {
      if (isGroupedDocumentBrowserModel(this.props.model))
        return this.props.model;
      else return emptyGroupedDocumentBrowserModel;
    },
    allDocumentPages() {
      const allDocuments_ = this.modelForAnnotations().allDocuments();
      if (allDocuments_ != null)
        return allDocuments_.reduce(
          (allDocumentPages, doc) => [...allDocumentPages, ...doc.pages],
          []
        );
      else return [];
    },
    componentDidMount() {
      this.fetchLines(this.currentPage());
      hotkeys.listenInComponent(this, AccountsPayable, {
        zoomIn: this.zoomIn,
        zoomOut: this.zoomOut,
        rotateLeft: this.rotateLeft,
        rotateRight: this.rotateRight,
        markIllegible: () => this.props.toggleMarkIllegibleData(
          this.props.model.selectedDocument,
          this.props.page
        ),
        toggleHidden: () => this.props.toggleHiddenData(
          this.props.model.selectedDocument,
          this.props.page
        )
      });
    },
    componentWillMount() {
      $(DataStoreService).on(
        "DataStoreService:documentPageReplaced",
        this.handlePageReplaced
      );
    },
    handlePageReplaced(_args, page) {
      if (page == null) {
        return;
      }
      const currentPage_ = this.currentPage();
      const key = pageKeyForAttachmentIsProcessingByPage(page);
      const currentPageFinishedProcessing = currentPage_ && currentPage_.document_id === page.document_id && currentPage_.number === page.number && this.attachmentIsProcessing() && !page.attachmentIsProcessing;
      const attachmentIsProcessingByPage = __spreadProps(__spreadValues({}, this.state.attachmentIsProcessingByPage), {
        [key]: page.attachmentIsProcessing
      });
      this.setState({
        attachmentIsProcessingByPage
      });
      if (currentPageFinishedProcessing)
        Flash.success("Saved annotations successfully!");
    },
    componentWillUnmount() {
      hotkeys.unlistenInComponent(this);
      $(DataStoreService).off(
        "DataStoreService:documentPageReplaced",
        this.handlePageReplaced
      );
    },
    componentWillReceiveProps(newProps) {
      this.setState({ justSaved: newProps.justSaved });
      if ((this.props.page && this.props.page.id) !== (newProps.page && newProps.page.id)) {
        this.fetchLines(newProps.page);
        this.resetToolState();
      }
    },
    // STATE
    adjustTone(adjustment, value) {
      this.props.dispatch(adjustTone(adjustment, value));
    },
    fetchLines(page) {
      if (page && page.id && _.isUndefined(page.lines)) {
        ApiService.addErrorHandler(
          fetch(`/api/document_pages/${page.id}/lines`).then((response) => {
            page.lines = response.lines;
            if (this.isMounted()) {
              this.forceUpdate();
            }
            return null;
          }),
          null,
          {
            caller: "DocumentBrowserMainImage.fetchLines"
          }
        );
      }
    },
    resetToolState() {
      this.zoomer = new Zoomer();
      this.setState({ zoomLevel: this.zoomer.zoomLevel, justSaved: false });
    },
    zoomIn() {
      this.zoomer.zoomIn();
      this.setState({ zoomLevel: this.zoomer.zoomLevel });
    },
    zoomOut() {
      this.zoomer.zoomOut();
      this.setState({ zoomLevel: this.zoomer.zoomLevel });
    },
    rotateLeft(_event) {
      if (this.state.updating) {
        return false;
      }
      this._withUpdate(documentEditor.rotateLeft(this.currentPage()));
    },
    rotateRight(_event) {
      if (this.state.updating) {
        return false;
      }
      this._withUpdate(documentEditor.rotateRight(this.currentPage()));
    },
    attachmentIsProcessing() {
      if (this.currentPage != null) {
        const pageKey = pageKeyForAttachmentIsProcessingByPage(
          this.currentPage()
        );
        return this.state.attachmentIsProcessingByPage[pageKey];
      }
      return false;
    },
    currentPage() {
      return this.props.model.selectedPage;
    },
    split() {
      const model = this.props.model;
      this._withUpdate(
        documentEditor.split(model.selectedDocument.id, model.selectedPage.id)
      );
    },
    merge() {
      const model = this.props.model;
      this._withUpdate(
        documentEditor.merge(
          model.selectedDocument.id,
          model.previousDocument().id
        )
      );
    },
    duplicate() {
      const model = this.props.model;
      this._withUpdate(documentEditor.duplicate(model.selectedDocument.id));
    },
    _withUpdate(promise) {
      this.setState({ updating: true });
      this.currentPage().lines = void 0;
      promise.then(() => {
        this.setState({ updating: false });
      }).catch(() => {
        this.setState({ updating: false });
        return {};
      });
    },
    toggleAnnotation() {
      this.props.dispatch(toggleAnnotatingStatus());
    },
    toggleHidden() {
      this.props.toggleHiddenData(
        this.props.model.selectedDocument,
        this.props.page
      );
    },
    // POD Modal Helper Functions
    openPodUncheckReasonModal: function(document, load) {
      this.setState({
        showPodUncheckReasonModal: true,
        podUncheckReasonDocument: document,
        podUncheckReasonLoad: load
      });
      if (this.props.forceUpdateAndRefreshPopout) {
        this.props.forceUpdateAndRefreshPopout();
      }
    },
    openPodCheckReasonModal: function(document, load) {
      this.setState({
        showPodCheckReasonModal: true,
        podCheckReasonDocument: document,
        podCheckReasonLoad: load
      });
      if (this.props.forceUpdateAndRefreshPopout) {
        this.props.forceUpdateAndRefreshPopout();
      }
    },
    // POD Toggle Handler
    handlePodToggle: function(document, field) {
      if (field === "includesPOD") {
        const load = this.props.load || this.props.selectedLoad;
        if (!load) {
          this.props.toggleDocumentData(document, field);
          return;
        }
        const currentIsPod = isPodForLoad(
          document,
          load,
          this.props.documentLoadRelationships
        );
        const newIsPod = !currentIsPod;
        if (shouldShowPodUncheckModal(currentIsPod, newIsPod)) {
          this.openPodUncheckReasonModal(document, load);
          return;
        }
        if (shouldShowPodCheckModal(currentIsPod, newIsPod)) {
          this.openPodCheckReasonModal(document, load);
          return;
        }
      }
      this.props.toggleDocumentData(document, field);
    },
    markIllegible() {
      this.props.toggleMarkIllegibleData(
        this.props.model.selectedDocument,
        this.props.page
      );
    },
    toneSliders() {
      if (this.props.annotating && this.props.showToneSliders) {
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "f-dropdown content medium open f-open-dropdown docviewer-tone-sliders",
            style: {
              position: "absolute",
              left: 0,
              top: "8em",
              zIndex: 9999
            }
          },
          /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("label", { htmlFor: "sharpen-slider" }, "Sharpen"), /* @__PURE__ */ React.createElement(
            "input",
            {
              type: "range",
              min: "0",
              max: "100",
              value: this.props.toneAdjustments.sharpen,
              id: "sharpen-slider",
              step: "1",
              onChange: (e) => this.adjustTone("sharpen", e.target.value)
            }
          ), " ", this.props.toneAdjustments.sharpen),
          /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("label", { htmlFor: "contrast-slider" }, "Contrast"), /* @__PURE__ */ React.createElement(
            "input",
            {
              type: "range",
              min: "-100",
              max: "100",
              value: this.props.toneAdjustments.contrast,
              id: "contrast-slider",
              step: "1",
              onChange: (e) => this.adjustTone(
                "contrast",
                e.target.value
              )
            }
          ), " ", this.props.toneAdjustments.contrast),
          /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("label", { htmlFor: "brightness-slider" }, "Brightness"), /* @__PURE__ */ React.createElement(
            "input",
            {
              type: "range",
              min: "-100",
              max: "100",
              value: this.props.toneAdjustments.brightness,
              id: "brightness-slider",
              step: "1",
              onChange: (e) => this.adjustTone(
                "brightness",
                e.target.value
              )
            }
          ), " ", this.props.toneAdjustments.brightness),
          this.maybeShowDespeckle()
        );
      }
    },
    maybeShowDespeckle() {
      if (showDespeckle()) {
        return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("label", { htmlFor: "despeckle-slider" }, "Despeckle"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "range",
            min: "0",
            max: "20",
            value: this.props.toneAdjustments.despeckle,
            id: "despeckle-slider",
            step: "1",
            onChange: (e) => this.adjustTone("despeckle", e.target.value)
          }
        ), " ", this.props.toneAdjustments.despeckle);
      }
    },
    noDocumentsView() {
      return /* @__PURE__ */ React.createElement("div", { className: "document-browser__main-image-container" }, /* @__PURE__ */ React.createElement("div", { className: "document-browser__main-image-container-no-images" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box--highlight" }, "No Documents Are Available")));
    },
    possiblePodUncheckReasonModal: function() {
      if (!this.state.showPodUncheckReasonModal) return null;
      const onClose = () => {
        const document = this.state.podUncheckReasonDocument;
        setPOD(document, true);
        this.setState({
          showPodUncheckReasonModal: false,
          podUncheckReasonDocument: null,
          podUncheckReasonLoad: null
        });
        if (this.props.forceUpdateAndRefreshPopout) {
          this.props.forceUpdateAndRefreshPopout();
        }
      };
      const onSubmit = (reasonCodes, otherReasonText) => {
        const document = this.state.podUncheckReasonDocument;
        const load = this.state.podUncheckReasonLoad;
        if (this.props.removeDeliveryDocumentSelectionsForDocument) {
          this.props.removeDeliveryDocumentSelectionsForDocument(document);
        }
        setPOD(document, false);
        loadDocumentRelationshipService.forcePodDispositionForDocument(
          document.id,
          false
        );
        const isConfirmSubmit = this.props.isConfirmAndSubmit;
        const extras = {
          load_state_id: load.id,
          page: isConfirmSubmit ? "confirm_and_submit" : "assign_to_load",
          pod_toggled: true,
          pod_reason_codes: reasonCodes,
          pod_reason: otherReasonText
        };
        this.setState({
          showPodUncheckReasonModal: false,
          podUncheckReasonDocument: null,
          podUncheckReasonLoad: null
        });
        Api.Documents.save(document, extras).then((data) => {
          if (this.props.updateShipments && data.tms_shipments) {
            this.props.updateShipments(data.tms_shipments);
          }
          if (this.props.forceUpdateAndRefreshPopout) {
            this.props.forceUpdateAndRefreshPopout();
          }
        });
      };
      return renderPodUncheckReasonModal({
        onClose,
        onSubmit,
        doc: this.state.podUncheckReasonDocument,
        loadState: this.state.podUncheckReasonLoad,
        documentLoadRelationships: this.props.documentLoadRelationships
      });
    },
    possiblePodCheckReasonModal: function() {
      if (!this.state.showPodCheckReasonModal) return null;
      const onClose = () => {
        const doc = this.state.podCheckReasonDocument;
        setPOD(doc, false);
        this.setState({
          showPodCheckReasonModal: false,
          podCheckReasonDocument: null,
          podCheckReasonLoad: null
        });
        if (this.props.forceUpdateAndRefreshPopout) {
          this.props.forceUpdateAndRefreshPopout();
        }
      };
      const onSubmit = (reasonCodes, otherReasonText) => {
        const doc = this.state.podCheckReasonDocument;
        const load = this.state.podCheckReasonLoad;
        setPOD(doc, true);
        loadDocumentRelationshipService.forcePodDispositionForDocument(
          doc.id,
          true
        );
        const isConfirmSubmit = this.props.isConfirmAndSubmit;
        const extras = {
          load_state_id: load.id,
          page: isConfirmSubmit ? "confirm_and_submit" : "assign_to_load",
          pod_toggled: true,
          pod_reason_codes: reasonCodes,
          pod_reason: otherReasonText
        };
        this.setState({
          showPodCheckReasonModal: false,
          podCheckReasonDocument: null,
          podCheckReasonLoad: null
        });
        Api.Documents.save(doc, extras).then((data) => {
          if (this.props.updateShipments && data.tms_shipments) {
            this.props.updateShipments(data.tms_shipments);
          }
          if (this.props.forceUpdateAndRefreshPopout) {
            this.props.forceUpdateAndRefreshPopout();
          }
        });
      };
      return renderPodCheckReasonModal({
        onClose,
        onSubmit,
        doc: this.state.podCheckReasonDocument,
        loadState: this.state.podCheckReasonLoad,
        documentLoadRelationships: this.props.documentLoadRelationships
      });
    },
    render() {
      if (!this.props.page) {
        return this.noDocumentsView();
      }
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          "data-component": "DocumentBrowserMainImage",
          className: "document-browser__main-image-container"
        },
        /* @__PURE__ */ React.createElement("div", { className: "document-browser__page-toolbar" }, /* @__PURE__ */ React.createElement(
          PageToolbar,
          {
            zoomIn: this.zoomIn,
            attachmentIsProcessing: this.attachmentIsProcessing(),
            canZoomIn: this.zoomer.canZoomIn(),
            zoomOut: this.zoomOut,
            canZoomOut: this.zoomer.canZoomOut(),
            rotateLeft: this.rotateLeft,
            rotateRight: this.rotateRight,
            split: this.split,
            canSplit: this.canSplit(),
            merge: this.merge,
            canMerge: this.canMerge(),
            duplicate: this.duplicate,
            allowsEditing: this.props.allowsEditing,
            downloadAllURL: this.downloadAllURL(),
            downloadURL: this.downloadURL(),
            annotate: this.toggleAnnotation,
            annotating: this.props.annotating,
            canToggleHidden: canToggleHidden(this.props.currentInvoice),
            toggleHidden: this.toggleHidden,
            markIllegible: this.markIllegible,
            canMarkIllegible: showMarkIllegibleButton(this.props),
            markedIllegible: this.props.page.illegible,
            viewEmail: viewEmail(this.props, this.history)
          }
        ), documentBrowserSubNav(
          __spreadProps(__spreadValues({}, this.props), {
            handlePodToggle: this.handlePodToggle
          }),
          this.history
        ), this.annotateToolbar(), this.toneSliders(), this.assignDocumentsSelector(), /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.state.updating }, /* @__PURE__ */ React.createElement("div", { className: bem("__wrapper") }, this.possibleTextAnnotationEditArea(), this.possibleZoomableImage()))),
        this.possiblePodUncheckReasonModal(),
        this.possiblePodCheckReasonModal()
      );
    },
    editTextAnnotation(e) {
      const annotation = this.props.editedTextAnnotation;
      if (annotation) {
        this.props.dispatch(
          editTextAnnotationText(annotation.guid, e.target.value)
        );
      }
    },
    doneEditingText(e) {
      e.preventDefault();
      this.props.dispatch(doneEditingTextAnnotation());
    },
    possibleTextAnnotationEditArea() {
      if (this.props.editedTextAnnotation) {
        return /* @__PURE__ */ React.createElement("form", { onSubmit: this.doneEditingText }, /* @__PURE__ */ React.createElement("div", { className: "document-browser__text-annotation-edit-area" }, /* @__PURE__ */ React.createElement(
          "textarea",
          {
            onChange: this.editTextAnnotation,
            value: this.props.editedTextAnnotation.data.text,
            placeholder: "Edit text\u2026"
          }
        ), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { type: "submit", className: "button--progress" }, "Done"), /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "#",
            style: { float: "right" },
            className: "button--caution alert",
            onClick: (e) => {
              e.preventDefault();
              this.props.dispatch(
                deleteAnnotation(this.props.editedTextAnnotation.guid)
              );
            }
          },
          "Delete annotation"
        ))));
      }
    },
    possibleZoomableImage() {
      const enabled = this.dragAndDropEnabled();
      if (!_.isEmpty(this.props.page)) {
        const urlsChanged = this.props.page != null && this.possibleZoomableImage.previouslySeenPage != null && (this.props.page.url !== this.possibleZoomableImage.previouslySeenPage.url || this.props.page.fullUrl !== this.possibleZoomableImage.previouslySeenPage.fullUrl || this.props.page.rawUrl !== this.possibleZoomableImage.previouslySeenPage.rawUrl || this.props.page.rawFullUrl !== this.possibleZoomableImage.previouslySeenPage.rawFullUrl);
        this.possibleZoomableImage.previouslySeenPage = Object.assign(
          {},
          this.props.page
        );
        return /* @__PURE__ */ React.createElement(
          ZoomableImage,
          {
            page: urlsChanged ? Object.assign({}, this.props.page) : this.props.page,
            textToHighlight: this.props.textToHighlight,
            dragAndDropEnabled: enabled,
            annotating: this.props.annotating,
            cropping: this.props.cropping,
            justSaved: this.state.justSaved,
            browserExpanded: this.props.browserExpanded,
            zoomLevel: this.zoomer.zoomLevel,
            annotationStampUrl: annotationStampUrl(this.props.model),
            toneAdjustments: this.props.toneAdjustments
          }
        );
      }
    },
    dragAndDropEnabled() {
      const page = this.currentPage();
      return this.zoomer.zoomLevel === 1 && !_.isEmpty(page.lines) && page.rotation === 0;
    },
    onProcessAttachment() {
      const currentPage_ = this.currentPage();
      if (currentPage_ != null) {
        const currentPageKey = pageKeyForAttachmentIsProcessingByPage(currentPage_);
        this.setState({
          attachmentIsProcessingByPage: __spreadProps(__spreadValues({}, this.state.attachmentIsProcessingByPage), {
            [currentPageKey]: true
          })
        });
      }
    },
    annotateToolbar() {
      const document = this.props.model.selectedDocument;
      if (this.props.allowsEditing && this.props.annotating && document) {
        return (
          // @ts-expect-error - TODO: fix TypeScript error
          /* @__PURE__ */ React.createElement(
            AnnotateToolbar,
            {
              dispatch: this.props.dispatch,
              savingAnnotations: this.props.savingAnnotations,
              attachmentIsProcessing: this.attachmentIsProcessing(),
              onProcessAttachment: this.onProcessAttachment,
              allowsEditing: this.props.allowsEditing,
              annotating: this.props.annotating,
              cropping: this.props.cropping,
              page: this.props.page,
              annotationStampUrl: annotationStampUrl(this.props.model)
            }
          )
        );
      }
    },
    downloadURL() {
      return documentEditor.downloadURL(this.props.model.selectedDocument.id);
    },
    downloadAllURL() {
      if (this.props.isConfirmAndSubmit || this.props.canDownloadAll) {
        let tokens;
        if (Auth._currentUser.account.factor_account) {
          tokens = this.props.model.selectedGroup.documents.map((d) => d.token).join();
        } else {
          const allDocuments = (
            // @ts-expect-error - TODO: fix TypeScript error
            this.modelForAnnotations().allDocuments()
          );
          tokens = allDocuments.map((d) => d.token).join();
        }
        return documentEditor.downloadAllURL(tokens);
      }
    },
    assignDocumentsSelector() {
      const load = this.onLoadUrl() ? this.props.load : this.props.selectedLoad;
      return getDocumentAssignmentComponent(
        flowStep(this.props),
        load,
        this.props.model.selectedDocument,
        Api.Account.currentSettings(),
        this.props.toggleDeliveryDocument,
        this.props.toggleCustomerLoadDocument,
        this.props.toggleShipmentDocument,
        this.allDocumentIds(),
        this.props.shipmentDocumentSelections,
        this.props.deliveryDocumentSelections,
        this.props.shipments,
        this.onLoadUrl()
      );
    },
    onLoadUrl() {
      var _a, _b;
      return !!this.props.load && ((_b = (_a = this.props.location) == null ? void 0 : _a.pathname) == null ? void 0 : _b.match(/\/loads\//));
    },
    allDocumentIds() {
      if (this.props.model.groups) {
        const documentIds = this.props.model.groups.map(
          (group) => group.documents.map((document) => document.id)
        );
        return _.flatten(documentIds);
      }
    },
    canMerge() {
      if (this.invoiceApproved()) {
        return false;
      }
      if (!this.propsAllowsSplitMerge()) {
        return false;
      }
      if (!this.props.model.previousDocument()) {
        return false;
      }
      if (Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled) {
        return this.props.model.previousDocument().document_batch_id === this.props.model.selectedDocument.document_batch_id;
      }
      return true;
    },
    invoiceApproved() {
      const invoice = this.props.currentInvoice;
      return invoice && invoice.state && invoice.state === "approved";
    },
    propsAllowsSplitMerge() {
      if (this.props.allowsSplitMerge === false) {
        return false;
      } else {
        return true;
      }
    },
    canSplit() {
      const model = this.props.model;
      return this.propsAllowsSplitMerge() && model.selectedDocument && model.selectedDocument.pages && model.selectedDocument.pages.map((p) => p.id).indexOf(model.selectedPage.id) > 0;
    }
  })
);
const connectedMainImage = connect(
  (state) => ({
    justSaved: state.annotationMode.justSaved,
    savingAnnotations: state.annotationMode.saving,
    annotating: state.annotationMode.annotating,
    cropping: state.annotationMode.cropping,
    editedTextAnnotation: state.textEditingMode,
    showToneSliders: state.annotationMode.showToneSliders,
    toneAdjustments: state.toneAdjustments
  }),
  null,
  null,
  { pure: false }
)(DocumentBrowserMainImage);
export default connectedMainImage;
